import React, {Component} from 'react';
import StandardCRUD from "../../../components/StandardCRUD" //component that used for standard crud from

import data_field from './_field'; // fields form
import SidebarDataMaster from '../SidebarDataMaster';
import SectionDataView from '../../../containers/_layout/SectionDataView';


class Klasifikasi extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      id_pk_column: 'id',
      id : this.props.match.params.id,
      url: { url_get_data : `/kategori/${this.props.match.params.id}/klasifikasi`, url_save_data: '/klasifikasi', url_update_data: '/klasifikasi',
             url_delete_data: '/klasifikasi', url_get_data_per: '/klasifikasi' },
      title: 'Master Klasifikasi',
      title_add : 'Add Data Master Klasifikasi', 
      fields: data_field.data, 
      url_parrent: '/master/kategori',
      columns: [ 
        { header: 'Kategori', id: 'kategori', accessor: 'kategori', child_accessor: null,
            Cell: row => {
                return (row.value.nama.substring(0, 25) + (row.value.nama.length > 25 ? '.....' : ''))
            }
        },
        { header: 'Nama Klasifikasi', id: 'nama', accessor: 'nama', child_accessor: null,
            Cell: row => {
                return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        }, 
        { header: 'Sub Klasifikasi', id: 'id', accessor: 'id', child_accessor: null,
            Cell: row => {
              return <button className="btn btn-xs pd-x-10 btn-outline-dark" 
                        onClick={() => this.props.history.push(`/master/kategori/${this.props.match.params.id}/klasifikasi/${row.value}/sub`)}><i className="fa fa-list"></i>
                    </button>
            }
        },       
    ],
    }
  }

  render() {
    return (
      <React.Fragment>
          <SidebarDataMaster location={this.props.location.pathname}/>
          <StandardCRUD 
                columns={this.state.columns} 
                url={this.state.url} 
                title={this.state.title} 
                title_add={this.state.title_add} 
                fields={this.state.fields} 
                id_pk={this.state.id} 
                add_form={true}
                id_pk_column={this.state.id_pk_column}
                style_container="content content-components"
                search_query=""
                search_column={true}
                url_parrent ={this.state.url_parrent}
          />
          <SectionDataView />
      </React.Fragment>
      
    );
  }
}

export default Klasifikasi;
